import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import './App.css';
import './styles/home-page-dark.css';
import './styles/home-page-light.css';
import './styles/storefront-pages-theme.css';
import { CartProvider } from './contexts/CartContext';
import { VehicleProvider } from './contexts/VehicleContext';
import { JobProvider } from './contexts/JobContext';
import { EscrowProvider } from './contexts/EscrowContext';

import Header from './component/Header';
import Footer from "./component/Footer";
import BottomNavigation from './component/BottomNavigation';
import { AuthProvider, USER_ROLES } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NotificationProvider } from './contexts/NotificationContext';
import { I18nProvider } from './contexts/I18nContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { storefrontShellClass } from './theme/themeClasses';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { InvoiceModalProvider, useInvoiceModal } from './contexts/InvoiceModalContext';
import SuperAdminDashboard from './component/dashboards/admin/SuperAdminDashboard';
import VendorDashboard from './component/dashboards/vendor/VendorDashboard';
import MechanicsDashboard from './component/dashboards/mechanics/MechanicsDashboard';
import GarageDashboard from './component/dashboards/garage/GarageDashboard';
import ShippingDashboard from './component/dashboards/shipping/ShippingDashboard';
import CustomerDashboard from './component/dashboards/customer/CustomerDashboard';
import DiagnosticForm from './features/diagnostics/DiagnosticForm';
import ChatbotSupport from './features/support/ChatbotSupport';
import PromotionalNotifications from './component/PromotionalNotifications';
import NotificationPermissionPrompt from './component/NotificationPermissionPrompt';
import LocationPreferencePrompt from './component/LocationPreferencePrompt';
import { LocationPreferenceProvider } from './contexts/LocationPreferenceContext';
import ScrollToTopButton from './component/ScrollToTopButton';
import PageBackButton from './component/PageBackButton';
import ThemeToggleButton from './component/ThemeToggleButton';
import { HeaderScrollProvider } from './contexts/HeaderScrollContext';
import LoadingBar from './component/LoadingBar';
import OfflineBanner from './component/OfflineBanner';
import PageTransition from './component/PageTransition';

import CartCheckout from './component/CartCheckout';
import ShippingAddress from './component/checkout/ShippingAddress';
import Review from './component/checkout/Review';
import CheckoutPaymentRoute from './component/CheckoutPaymentRoute';
import OrderTracking from './component/OrderTracking';
import OrderConfirmation from './component/checkout/OrderConfirmation';
import { BoodmoUi } from './component/BoodmoUi';
import PartsByCategoryHome from './component/PartsByCategoryHome';
import CurrentOffers from './component/CurrentOffers';
import SearchSection from "./component/SearchSection";
import BrandTrustAndCarMakers from './component/BrandTrustAndCarMakers';
import ProductRecommendations from './component/ProductRecommendations';
import { Garage } from './component/Garage';
import { MyAccount } from './component/MyAccount';
import { MyProfile } from './component/MyProfile';
import NotificationSettings from './component/NotificationSettings';
import { MyOrder } from './component/MyOrder';
import ReturnsDisputes from './component/ReturnsDisputes';
import { MyWishlist } from './component/MyWishlist';
import { Document } from './component/Document';
import { Company_GST } from './component/Company_GST';
import { Addresses } from "./component/Addresses";
import Contact from "./component/Contact";
import Article_review from "./component/Article_Review";
import Wallet from "./component/Wallet";
import Membership from "./component/Membership";
import LuckyDraw from "./component/LuckyDraw";
import Location from "./component/Location";
import Notifications from "./component/Notifications";
import Login from "./component/Login";
import LoginPhone from "./component/auth/LoginPhone";
import LoginOTP from "./component/auth/LoginOTP";
import VehiclePickerGate from "./component/auth/VehiclePickerGate";
import HomeFeedSection from "./component/HomeFeedSection";
import WarrantyCards from "./component/auth/WarrantyCards";
import HealthPassport from "./component/auth/HealthPassport";
import HealthPassportPublic from "./component/auth/HealthPassportPublic";
import AccountSettings from "./component/auth/AccountSettings";
import LoginIntegrated from "./component/LoginIntegrated";
import PartnerLogin from "./component/auth/PartnerLogin";
import ForgotPassword from "./component/Forgot_Password";
import Signup from "./component/Signup";
import PartnerSignupPending from "./component/auth/PartnerSignupPending";
import OnboardingSelectRole from "./component/onboarding/OnboardingSelectRole";
import OnboardingCustomer from "./component/onboarding/OnboardingCustomer";
import OnboardingVendor from "./component/onboarding/OnboardingVendor";
import OnboardingDelivery from "./component/onboarding/OnboardingDelivery";
import OnboardingMechanic from "./component/onboarding/OnboardingMechanic";
import OnboardingGarage from "./component/onboarding/OnboardingGarage";
import VendorPage from "./component/VendorPage";
import HomeVehiclePartsStrip from "./component/HomeVehiclePartsStrip";
import SearchByCategory from "./component/SearchByCategory";
import GarageServicesDirectory from "./component/GarageServicesDirectory";
import GarageDiscovery from "./component/GarageDiscovery";
import GarageProfile from "./component/GarageProfile";
import SellerStorefront from "./component/SellerStorefront";
import GarageBooking from "./component/service/GarageBooking";
import SplitGarageBooking from "./component/service/SplitGarageBooking";
import CustomTuningJobForm from "./component/service/CustomTuningJobForm";
import TransformationProjectForm from "./component/service/TransformationProjectForm";
import BookingStatus from "./component/service/BookingStatus";
import WhyChooseAftermarket from "./component/WhyChooseAftermarket";
import BuyerSearchEngine from "./component/search/BuyerSearchEngine";
import ProductDetail from "./component/ProductDetail";
import PartDetailNew from "./component/PartDetailNew";
import PartDetailUsed from "./component/PartDetailUsed";
import PartDetailBody from "./component/PartDetailBody";
import CatalogNodePage from "./component/catalog/CatalogNodePage";
import SubSystemBrowse from "./component/discovery/SubSystemBrowse";
import SubSystemListing from "./component/discovery/SubSystemListing";
import SubSystemCategories from "./component/discovery/SubSystemCategories";
import VehiclePartsBrowse from "./component/discovery/VehiclePartsBrowse";
import VehicleSearchResults from "./component/VehicleSearchResults";
import OEMCatalogue from "./component/catalogue/OEMCatalogue";
import ServiceBooking from "./component/service/ServiceBooking";
import GarageSelect from "./component/service/GarageSelect";
import JobDetails from "./component/service/JobDetails";
import VehicleJobCard from "./component/service/VehicleJobCard";
import ServiceJobPayment from "./component/service/ServiceJobPayment";
import BridgeApproval from "./component/bridge/BridgeApproval";
import BridgeAmendment from "./component/bridge/BridgeAmendment";
import BridgeCollection from "./component/bridge/BridgeCollection";
import MyServiceJobs from "./component/service/MyServiceJobs";
import UsedPartsSellerCta from './component/home/UsedPartsSellerCta';
import CatalogPage from "./component/catalogue/CataloguePage";
import VehicleMaker from "./component/Vehicles/VehicleMaker";
import MaintenanceServiceParts from "./component/catalogue/MaintenanceServiceParts";
import Filters from "./component/catalogue/Filters";
import Windscreen_Cleaning_System from "./component/catalogue/Windscreen_Cleaning_System";
import Car_Accessories from "./component/catalogue/Car_Accessories";
import Lighting from "./component/catalogue/Lighting";
import Control_Cables from "./component/catalogue/Control_Cables";
import Break_System from "./component/catalogue/Break_System";
import Bearing from "./component/catalogue/Bearing";
import { Clutch_System } from "./component/catalogue/Clutch_System";
import { Electric_Components } from "./component/catalogue/Electric_Components";
import Engine from "./component/catalogue/Engine";
import Engine_Cooling_System from "./component/catalogue/Engine_Cooling_System";
import Exhaust_System from "./component/catalogue/Exhaust_System";
import AirConditioning from "./component/catalogue/AirConditioning";
import Fuelsupply_System from "./component/catalogue/Fuelsupply_System";
import Gasket_SealingRings from "./component/catalogue/Gasket_SealingRings";
import Ignition_Glowplug from "./component/catalogue/Ignition_Glowplug";
import Interior_Comfort from "./component/catalogue/Interior_Comfort";
import Body from "./component/catalogue/Body";
import Oil_Fluids from "./component/catalogue/Oil_Fluids";
import Pipes_Hoses from "./component/catalogue/Pipes_Hoses";
import RepairKits from "./component/catalogue/RepairKits";
import Sensors_ControlUnits from "./component/catalogue/Sensors_ControlUnits";
import Steering from "./component/catalogue/Steering";
import Suspention_Arms from "./component/catalogue/Suspention_Arms";
import TowbarParts from "./component/catalogue/TowbarParts";
import Transmission from "./component/catalogue/Transmission";
import Trims from "./component/catalogue/Trims";
import Tyres_Alloys from "./component/catalogue/Tyres_Alloys";
import Universal from "./component/catalogue/Universal";
import Wheels from "./component/catalogue/Wheels";
import Belts_Chains_Rollers from "./component/catalogue/Belts_Chains_Rollers";
import Belt from "./component/catalogue/Belt";
import TimingBelt from "./component/catalogue/TimingBelt";
import TimingBeltDetail from "./component/catalogue/TimingBeltDetail";
import TimingBeltKit from "./component/catalogue/TimingBeltKit";
import VBelt from "./component/catalogue/VBelt";
import BrakeParts from "./component/catalogue/BrakeParts";
import SubCategoryPage from "./component/catalogue/SubCategoryPage";
import ClutchParts from "./component/catalogue/ClutchParts";
import EngineOilParts from "./component/catalogue/EngineOilParts";
import FilterParts from "./component/catalogue/FilterParts";
import GlowPlugParts from "./component/catalogue/GlowPlugParts";
import HornParts from "./component/catalogue/HornParts";
import LightParts from "./component/catalogue/LightParts";
import { Brands } from "./component/brand/Brands";
import BrandDetail from "./component/brand/BrandDetail";
import VehiclePage from "./component/Vehicles/VehiclePage";
import { Maruti } from "./component/Vehicles/Maruti";
import { Hyundai } from "./component/Vehicles/Hyundai";
import { Mahindra } from "./component/Vehicles/Mahindra";
import { Tata } from "./component/Vehicles/Tata";
import { Chevrolet } from "./component/Vehicles/Chevrolet";
import { Honda } from "./component/Vehicles/Honda";
import { Skoda } from "./component/Vehicles/Skoda";
import { Vw } from "./component/Vehicles/Vw";
import { Toyota } from "./component/Vehicles/Toyota";
import { Nissan } from "./component/Vehicles/Nissan";
import { Renault } from "./component/Vehicles/Renault";
import { Ford } from "./component/Vehicles/Ford";
import { Fiat } from "./component/Vehicles/Fiat";
import { Kia } from "./component/Vehicles/Kia";
import { AshokLayland } from "./component/Vehicles/AshokLayland";
import { Audi } from "./component/Vehicles/Audi";
import ModelDetail from "./component/Vehicles/ModelDetail";
import FAQ from "./features/support/FAQ";
import ReturnPolicy from "./features/support/ReturnPolicy";
import SellOnSperaloForm from "./assets/SellOnSperalo";

// Pages from pages folder
import About from "./component/pages/About";
import APISolution from "./component/pages/APISolution";
import BuyersPolicy from "./component/pages/BuyersPolicy";
import Careers from "./component/pages/Careers";
import DamagedParts from "./component/pages/DamagedParts";
import Disclaimer from "./component/pages/Disclaimer";
import DiscoveryPoints from "./component/pages/DiscoveryPoints";
import InvestorRelations from "./component/pages/InvestorRelations";
import Offers from "./component/pages/Offers";
import PrivacyPolicy from "./component/pages/PrivacyPolicy";
import SellersPolicy from "./component/pages/SellersPolicy";
import Sitemap from "./component/pages/Sitemap";
import Sitemap2 from "./component/pages/Sitemap2";
import Suppliers from "./component/pages/Suppliers";
import TermsOfUse from "./component/pages/TermsOfUse";
import Support from "./component/pages/Support";
import Articles from "./component/pages/Articles";
import SellYourCar from "./component/pages/SellYourCar";
import ListYourGarage from "./component/pages/ListYourGarage";





// Component to scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Component to conditionally render Header/Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const { invoiceModalOpen } = useInvoiceModal();
  const { isDark } = useTheme();

  const isDashboardRoute =
    location.pathname.startsWith('/admin/') ||
    location.pathname.startsWith('/vendor/') ||
    location.pathname.startsWith('/mechanics/') ||
    location.pathname.startsWith('/garage/') ||
    location.pathname.startsWith('/shipping/') ||
    location.pathname.startsWith('/customer/');

  const useLightSurface =
    ['/login', '/login/partner', '/signup', '/forgot-password', '/vehicle-picker'].includes(location.pathname) ||
    location.pathname.startsWith('/signup/') ||
    location.pathname.startsWith('/onboarding/') ||
    location.pathname.startsWith('/checkout') ||
    location.pathname.startsWith('/service/') ||
    location.pathname.startsWith('/bridge/');

  /** Public website routes (excludes dashboards, auth, checkout) */
  const isStorefrontRoute = !isDashboardRoute && !useLightSurface;

  useEffect(() => {
    const root = document.documentElement;
    root.style.colorScheme = isDark ? 'dark' : 'light';

    if (isStorefrontRoute) {
      document.body.classList.add('storefront-route');
      document.body.classList.toggle('home-page-route', isDark);
    } else {
      document.body.classList.remove('storefront-route');
      document.body.classList.remove('home-page-route');
    }
    return () => {
      document.body.classList.remove('storefront-route');
      document.body.classList.remove('home-page-route');
    };
  }, [isStorefrontRoute, isDark]);

  const hideHeaderFooter = [
    "/login",
    "/login/partner",
    "/signup",
    "/forgot-password",
    "/list-your-garage",
    "/account",
    "/admin/dashboard",
    "/vendor/dashboard",
    "/mechanics/dashboard",
    "/garage/dashboard",
    "/shipping/dashboard",
    "/customer/dashboard",
    "/wallet",
    "/membership",
    "/notifications"
  ].includes(location.pathname) ||
    location.pathname.startsWith("/signup/") ||
    isDashboardRoute ||
    location.pathname.startsWith("/onboarding/") ||
    location.pathname.startsWith("/bridge/") ||
    location.pathname.startsWith("/checkout") ||
    location.pathname === "/cart";
  const hideFooter = hideHeaderFooter || location.pathname.startsWith("/checkout") || location.pathname.startsWith("/service/booking");
  const hideBottomNavigation =
    hideHeaderFooter && !["/cart", "/account"].includes(location.pathname);
  return (
    <HeaderScrollProvider>
    <>
      <OfflineBanner />
      <LoadingBar />
      {!hideHeaderFooter && <Header />}
      <div
        className={!hideHeaderFooter ? "pb-24 lg:pb-32" : ""}
        style={
          !hideHeaderFooter
            ? {
                paddingTop: "var(--sp-storefront-header-height, 9.25rem)",
                paddingBottom: "calc(env(safe-area-inset-bottom) + 2rem)",
              }
            : {}
        }
      >
        <PageTransition>
          {isStorefrontRoute ? (
            <div className={storefrontShellClass(isDark)}>
              {children}
            </div>
          ) : (
            children
          )}
        </PageTransition>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        limit={5}
        stacked
      />
      {!hideBottomNavigation && !invoiceModalOpen && <BottomNavigation />}
      {!hideFooter && <Footer />}
      {!hideHeaderFooter && <ChatbotSupport />}
      {hideHeaderFooter && <ThemeToggleButton variant="fixed" />}
      {isStorefrontRoute && (
        <PageBackButton variant={hideHeaderFooter ? 'headerless' : 'storefront'} />
      )}
      <ScrollToTopButton />
      <LocationPreferencePrompt />
      <NotificationPermissionPrompt />
      <PromotionalNotifications />
    </>
    </HeaderScrollProvider>
  );
};

/** Legacy /search/:pn → unified buyer search engine */
function LegacyPartSearchRedirect() {
  const { pn } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set('mode', 'part');
  if (pn) params.set('q', decodeURIComponent(pn));
  const qs = params.toString();
  return <Navigate to={`/search${qs ? `?${qs}` : ''}`} replace />;
}

function App() {
  return (
    <I18nProvider>
      <ThemeProvider>
      <CurrencyProvider>
        <AuthProvider>
          <NotificationProvider>
            <VehicleProvider>
              <JobProvider>
                <EscrowProvider>
                  <CartProvider>
                    <Router
                      future={{
                        v7_startTransition: true,
                        v7_relativeSplatPath: true,
                      }}
                    >
                      <InvoiceModalProvider>
                        <LocationPreferenceProvider>
                        <ScrollToTop />
                        <Layout>
                          <Routes>
                            {/* Home Page */}
                            <Route
                              path="/"
                              element={
                                <>
                                  <BoodmoUi />
                                  <UsedPartsSellerCta />
                                  <HomeVehiclePartsStrip />
                                  <HomeFeedSection />
                                  <PartsByCategoryHome />
                                  <SearchSection />
                                  <SearchByCategory />
                                  {/* Garages & mechanics hidden from home — use bottom nav / account menu */}
                                  <BrandTrustAndCarMakers />
                                  <CurrentOffers />
                                  <Article_review
                                    items={[{ label: "Articles and Reviews", href: "/pages/article/" }]}
                                  />
                                  {/* <SpareloPage /> */}
                                </>
                              }
                            />

                            {/* Authentication Pages - Login is main entry point */}
                            <Route path="/login" element={<Login />} />
                            <Route path="/login/partner" element={<PartnerLogin />} />
                            <Route path="/login-phone" element={<LoginPhone />} />
                            <Route path="/login-otp" element={<LoginOTP />} />

                            {/* Legacy used-seller registration — unified partner signup */}
                            <Route path="/used-seller/register/*" element={<Navigate to="/signup" replace />} />

                            <Route path="/vehicle-picker" element={<VehiclePickerGate />} />
                            <Route path="/home-feed" element={<Navigate to="/" replace />} />
                            <Route
                              path="/warranty-cards"
                              element={
                                <ProtectedRoute>
                                  <WarrantyCards />
                                </ProtectedRoute>
                              }
                            />
                            <Route path="/passport/public/:shareToken" element={<HealthPassportPublic />} />
                            <Route path="/bridge/amendment/:token" element={<BridgeAmendment />} />
                            <Route path="/bridge/collection/:token" element={<BridgeCollection />} />
                            <Route path="/bridge/:token" element={<BridgeApproval />} />
                            <Route
                              path="/health-passport"
                              element={
                                <ProtectedRoute>
                                  <HealthPassport />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/account"
                              element={
                                <ProtectedRoute>
                                  <MyAccount />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/account-settings"
                              element={
                                <ProtectedRoute>
                                  <AccountSettings />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/mywishlist"
                              element={<Navigate to="/account-settings?tab=wishlist" replace />}
                            />
                            <Route path="/login-email" element={<LoginIntegrated />} />
                            <Route path="/register" element={<Navigate to="/signup" replace />} />
                            <Route path="/signup" element={<Signup />} />
                            <Route path="/signup/pending" element={<PartnerSignupPending />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />

                            {/* Onboarding - role-specific forms (logged-in partners) */}
                            <Route path="/onboarding/select-role" element={<ProtectedRoute><OnboardingSelectRole /></ProtectedRoute>} />
                            <Route path="/onboarding/customer" element={<ProtectedRoute><OnboardingCustomer /></ProtectedRoute>} />
                            <Route path="/onboarding/vendor" element={<ProtectedRoute><OnboardingVendor /></ProtectedRoute>} />
                            <Route path="/onboarding/delivery" element={<ProtectedRoute><OnboardingDelivery /></ProtectedRoute>} />
                            <Route path="/onboarding/mechanics" element={<ProtectedRoute><OnboardingMechanic /></ProtectedRoute>} />
                            <Route path="/onboarding/garage" element={<ProtectedRoute><OnboardingGarage /></ProtectedRoute>} />

                            {/* Dashboard Routes - Protected */}
                            <Route
                              path="/admin/dashboard/*"
                              element={
                                <ProtectedRoute
                                  allowedRoles={[USER_ROLES.SUPER_ADMIN]}
                                >
                                  <SuperAdminDashboard />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/vendor/dashboard/*"
                              element={
                                <ProtectedRoute allowedRoles={[USER_ROLES.VENDOR, USER_ROLES.USED_VENDOR]}>
                                  <VendorDashboard />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/mechanics/dashboard/*"
                              element={
                                <ProtectedRoute allowedRoles={[USER_ROLES.MECHANICS]}>
                                  <MechanicsDashboard />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/garage/dashboard/*"
                              element={
                                <ProtectedRoute allowedRoles={[USER_ROLES.GARAGE]}>
                                  <GarageDashboard />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/shipping/dashboard/*"
                              element={
                                <ProtectedRoute allowedRoles={[USER_ROLES.SHIPPING]}>
                                  <ShippingDashboard />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/customer/dashboard/*"
                              element={
                                <ProtectedRoute allowedRoles={[USER_ROLES.CUSTOMER]}>
                                  <CustomerDashboard />
                                </ProtectedRoute>
                              }
                            />

                            {/* Other Pages */}
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/vendor" element={<VendorPage />} />
                            <Route path="/brands" element={<Brands />} />
                            <Route path="/brands/:brandSlug" element={<BrandDetail />} />
                            {/* Protected Routes - Require Authentication */}
                            <Route
                              path="/cart"
                              element={
                                <ProtectedRoute>
                                  <CartCheckout />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/checkout"
                              element={
                                <ProtectedRoute>
                                  <CartCheckout />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/checkout/address"
                              element={
                                <ProtectedRoute>
                                  <ShippingAddress />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/checkout/review"
                              element={
                                <ProtectedRoute>
                                  <Review />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/checkout/payment"
                              element={
                                <ProtectedRoute>
                                  <CheckoutPaymentRoute />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/orders/:orderId/track"
                              element={
                                <ProtectedRoute>
                                  <OrderTracking />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/checkout/confirmation"
                              element={
                                <ProtectedRoute>
                                  <OrderConfirmation />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/myprofile"
                              element={
                                <ProtectedRoute>
                                  <MyProfile />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/notification-settings"
                              element={
                                <ProtectedRoute>
                                  <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
                                    <div className="max-w-4xl mx-auto">
                                      <h1 className="text-2xl font-bold text-gray-900 mb-6">Notification Settings</h1>
                                      <NotificationSettings />
                                    </div>
                                  </div>
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/track-order"
                              element={<Navigate to="/myorder" replace />}
                            />
                            <Route
                              path="/myorder"
                              element={
                                <ProtectedRoute>
                                  <MyOrder />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/returns-disputes"
                              element={
                                <ProtectedRoute>
                                  <ReturnsDisputes />
                                </ProtectedRoute>
                              }
                            />
                            {/* Other Routes */}
                            <Route path="/wallet" element={<Navigate to="/account-settings?tab=wallet" replace />} />
                            <Route path="/membership" element={<Membership />} />
                            <Route path="/lucky-draw" element={<LuckyDraw />} />
                            <Route path="/location" element={<Location />} />
                            <Route path="/notifications" element={<Navigate to="/account-settings?tab=notifications" replace />} />
                            <Route path="/category" element={<SearchByCategory />} />
                            <Route path="/garages" element={<GarageDiscovery />} />
                            <Route path="/garages/:garageId" element={<GarageProfile />} />
                            <Route path="/garage/quote-request" element={<CustomTuningJobForm />} />
                            <Route path="/garage/project-intake" element={<TransformationProjectForm />} />
                            <Route path="/seller/:slug" element={<SellerStorefront />} />
                            <Route path="/garage-services" element={<GarageServicesDirectory />} />
                            <Route path="/garage" element={<Garage />} />
                            <Route path="/document" element={<Document />} />
                            <Route path="/company_gst" element={<Company_GST />} />
                            <Route path="/addresses" element={<Navigate to="/account-settings?tab=addresses" replace />} />
                            <Route path="/support" element={<Navigate to="/account-settings?tab=support" replace />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route path="/return-policy" element={<ReturnPolicy />} />

                            <Route path="/sell-your-car" element={<SellYourCar />} />

                            <Route path="/list-your-garage" element={<ListYourGarage />} />

                            <Route path="/sell-your-car" element={<SellOnSperaloForm />} />

                            {/* Pages from pages folder */}
                            <Route path="/about" element={<About />} />
                            <Route path="/api-solution" element={<APISolution />} />
                            <Route path="/articles" element={<Articles />} />
                            <Route path="/buyers-policy" element={<BuyersPolicy />} />
                            <Route path="/careers" element={<Careers />} />
                            <Route path="/damaged-parts" element={<DamagedParts />} />
                            <Route path="/disclaimer" element={<Disclaimer />} />
                            <Route path="/discovery-points" element={<DiscoveryPoints />} />
                            <Route path="/investor-relations" element={<InvestorRelations />} />
                            <Route path="/offers" element={<Offers />} />
                            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                            <Route path="/sellers-policy" element={<SellersPolicy />} />
                            <Route path="/sitemap" element={<Sitemap />} />
                            <Route path="/sitemap2" element={<Sitemap2 />} />
                            <Route path="/suppliers" element={<Suppliers />} />
                            <Route path="/terms-of-use" element={<TermsOfUse />} />

                            <Route path="/catalog" element={<CatalogPage />} />
                            <Route path="/catalog/maintenance_service_parts/" element={<MaintenanceServiceParts />} />
                            <Route path="/catalog/4032-belts/" element={<Belt />} />
                            <Route path="/catalog/4390-timing_belt/" element={<TimingBelt />} />
                            <Route path="/catalog/4033-time_belt/" element={<TimingBelt />} />
                            <Route path="/catalog/timing-belt/:itemId" element={<TimingBeltDetail />} />
                            <Route path="/catalog/4393-timing_belt_kit/" element={<TimingBeltKit />} />
                            <Route path="/catalog/3720-v_belt/" element={<VBelt />} />
                            <Route path="/catalog/3713-brakes/" element={<BrakeParts />} />
                            <Route path="/catalog/4027-clutch/" element={<ClutchParts />} />
                            <Route path="/catalog/5193-engine_oil/" element={<EngineOilParts />} />
                            <Route path="/catalog/3625-filters/" element={<FilterParts />} />
                            <Route path="/catalog/4385-glow_plug/" element={<GlowPlugParts />} />
                            <Route path="/catalog/4064-horns/" element={<HornParts />} />
                            <Route path="/catalog/4028-light/" element={<LightParts />} />
                            <Route path="/catalog/filters/" element={<Filters />} />
                            <Route path="/catalog/windscreen_cleaning_system/" element={<Windscreen_Cleaning_System />} />
                            <Route path="/catalog/car_accessories/" element={<Car_Accessories />} />
                            <Route path="/catalog/lighting/" element={<Lighting />} />
                            <Route path="/catalog/control_cables/" element={<Control_Cables />} />
                            <Route path="/catalog/brakes/" element={<Break_System />} />
                            <Route path="/catalog/bearings/" element={<Bearing />} />
                            <Route path="/catalog/clutch/" element={<Clutch_System />} />
                            <Route path="/catalog/electric_components/" element={<Electric_Components />} />
                            <Route path="/catalog/engine/" element={<Engine />} />
                            <Route path="/catalog/cooling_system/" element={<Engine_Cooling_System />} />
                            <Route path="/catalog/exhaust/" element={<Exhaust_System />} />
                            <Route path="/catalog/air_conditioning/" element={<AirConditioning />} />
                            <Route path="/catalog/fuelsystem/" element={<Fuelsupply_System />} />
                            <Route path="/catalog/Gasket_SealingRings/" element={<Gasket_SealingRings />} />
                            <Route path="/catalog/ignition_glowplug/" element={<Ignition_Glowplug />} />
                            <Route path="/catalog/interior_comfort/" element={<Interior_Comfort />} />
                            <Route path="/catalog/body/" element={<Body />} />
                            <Route path="/catalog/oilsfluids/" element={<Oil_Fluids />} />
                            <Route path="/catalog/pipes_hoses/" element={<Pipes_Hoses />} />
                            <Route path="/catalog/repair_kits/" element={<RepairKits />} />
                            <Route path="/catalog/sensors_control_units/" element={<Sensors_ControlUnits />} />
                            <Route path="/catalog/steering/" element={<Steering />} />
                            <Route path="/catalog/suspension/" element={<Suspention_Arms />} />
                            <Route path="/catalog/towbar/" element={<TowbarParts />} />
                            <Route path="/catalog/transmission/" element={<Transmission />} />
                            <Route path="/catalog/trims/" element={<Trims />} />
                            <Route path="/catalog/tyres_and_alloys/" element={<Tyres_Alloys />} />
                            <Route path="/catalog/universal/" element={<Universal />} />
                            <Route path="/catalog/wheels/" element={<Wheels />} />
                            <Route path="/catalog/drive_belts/" element={<Belts_Chains_Rollers />} />


                            <Route path="/vehicles/vehiclepage" element={<VehiclePage />} />
                            <Route path="/vehicles/maruti" element={<Maruti />} />
                            <Route path="/vehicles/hyundai" element={<Hyundai />} />
                            <Route path="/vehicles/mahindra" element={<Mahindra />} />
                            <Route path="/vehicles/tata" element={<Tata />} />
                            <Route path="/vehicles/chevrolet" element={<Chevrolet />} />
                            <Route path="/vehicles/honda" element={<Honda />} />
                            <Route path="/vehicles/skoda" element={<Skoda />} />
                            <Route path="/vehicles/vw" element={<Vw />} />
                            <Route path="/vehicles/toyota" element={<Toyota />} />
                            <Route path="/vehicles/nissan" element={<Nissan />} />
                            <Route path="/vehicles/renault" element={<Renault />} />
                            <Route path="/vehicles/ford" element={<Ford />} />
                            <Route path="/vehicles/fiat" element={<Fiat />} />
                            <Route path="/vehicles/kia" element={<Kia />} />
                            <Route path="/vehicles/ashok-layland" element={<AshokLayland />} />
                            <Route path="/vehicles/audi" element={<Audi />} />
                            <Route path="/vehicles/:maker/:modelId" element={<ModelDetail />} />

                            {/* Legacy search URLs → catalog */}
                            <Route path="/search" element={<BuyerSearchEngine />} />
                            <Route path="/search/:pn" element={<LegacyPartSearchRedirect />} />

                            {/* Product detail page for back_url_id - Must come before catch-all */}
                            {/* These routes must be more specific to match before the catch-all */}
                            <Route path="/product/:itemId" element={<ProductDetail />} />
                            <Route path="/catalog/body-p-:itemId" element={<PartDetailBody />} />
                            <Route path="/catalog/body-p-:itemId/" element={<PartDetailBody />} />
                            <Route path="/catalog/used-p-:itemId" element={<PartDetailUsed />} />
                            <Route path="/catalog/used-p-:itemId/" element={<PartDetailUsed />} />
                            <Route path="/catalog/part-p-:itemId" element={<PartDetailNew />} />
                            <Route path="/catalog/part-p-:itemId/" element={<PartDetailNew />} />
                            <Route path="/catalog/node/:catalogNodeId" element={<CatalogNodePage />} />
                            <Route path="/discovery/subsystems" element={<SubSystemBrowse />} />
                            <Route path="/discovery/browse/:subSystemSlug" element={<SubSystemListing />} />
                            <Route path="/discovery/subsystem/:subSystem" element={<SubSystemCategories />} />
                            <Route path="/discovery/my-vehicle" element={<VehiclePartsBrowse />} />

                            {/* Catch-all route for catalog sub-categories (e.g., /catalog/4079-accessory_kit_disc_brake_pads/) */}
                            {/* This handles all other catalog routes that don't match specific patterns above */}
                            {/* Note: SubCategoryPage falls back to PartDetailNew for "part-p-*" slugs */}
                            <Route path="/catalog/:categorySlug" element={<SubCategoryPage />} />
                            <Route path="/catalog/:categorySlug/" element={<SubCategoryPage />} />

                            {/* Vehicle-based search landing */}
                            <Route path="/vehicle-search" element={<VehicleSearchResults />} />
                            <Route path="/oem-catalogue" element={<OEMCatalogue />} />
                            <Route path="/vehicles" element={<VehicleMaker />} />

                            {/* Service: Garage select then booking */}
                            <Route
                              path="/service/garage/:garageId"
                              element={
                                <ProtectedRoute>
                                  <GarageSelect />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/service/jobs"
                              element={
                                <ProtectedRoute>
                                  <MyServiceJobs />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/service/booking/split"
                              element={
                                <ProtectedRoute>
                                  <SplitGarageBooking />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/service/booking"
                              element={
                                <ProtectedRoute>
                                  <ServiceBooking />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/service/booking/status/:bookingId"
                              element={
                                <ProtectedRoute>
                                  <BookingStatus />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/service/booking/:garageId"
                              element={
                                <ProtectedRoute>
                                  <GarageBooking />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/service/job/:jobId/review"
                              element={<JobDetails />}
                            />
                            <Route
                              path="/service/job/:jobId"
                              element={
                                <ProtectedRoute>
                                  <JobDetails />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/service/job/:jobId/jobcard"
                              element={
                                <ProtectedRoute>
                                  <VehicleJobCard />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/service/job/:jobId/payment"
                              element={
                                <ProtectedRoute>
                                  <ServiceJobPayment />
                                </ProtectedRoute>
                              }
                            />
                          </Routes>
                        </Layout>
                        </LocationPreferenceProvider>
                      </InvoiceModalProvider>
                    </Router>
                  </CartProvider>
                </EscrowProvider>
              </JobProvider>
            </VehicleProvider>
          </NotificationProvider>
        </AuthProvider>
      </CurrencyProvider>
      </ThemeProvider>
    </I18nProvider>
  );
}

export default App;
